module.exports = __webpack_public_path__ + "img/nt107-05-81-1.prt.14df6b49.jpg";